import type { RemoteApiError } from "../../hooks/Remote/useRemote/types";

function readStatusCode(error: unknown): number | undefined {
  if (!error || typeof error !== "object") {
    return undefined;
  }
  return (error as RemoteApiError).response?.data?.statusCode;
}

function readErrorMessage(error: unknown): string {
  if (!error || typeof error !== "object") {
    return "";
  }
  const data = (error as RemoteApiError).response?.data;
  if (typeof data?.message === "string") {
    return data.message;
  }
  return "";
}

/** Maps public consent API failures to visitor-facing i18n keys. */
export function mapVisitConsentPublicErrorKey(error: unknown): string {
  const statusCode = readStatusCode(error);
  const message = readErrorMessage(error).toLowerCase();

  if (statusCode === 403) {
    return "_visitorConsent_featureDisabled";
  }
  if (statusCode === 429) {
    return "_visitorConsent_rateLimited";
  }
  if (statusCode === 404) {
    return "_visitorConsent_invalidLink";
  }
  if (statusCode === 400) {
    if (message.includes("expired")) {
      return "_visitorConsent_tokenExpired";
    }
    if (message.includes("already been used") || message.includes("already used")) {
      return "_visitorConsent_alreadySubmitted";
    }
    return "_visitorConsent_confirmError";
  }
  if (statusCode === 409) {
    return "_visitorConsent_alreadySubmitted";
  }

  return "_visitorConsent_confirmError";
}
